// packages/preferences/src/store/constants.ts
var STORE_NAME = "core/preferences";
export {
  STORE_NAME
};
//# sourceMappingURL=constants.mjs.map
